import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
// import {getToken} from '@/utils/auth'
import store from '../store'
// 创建axios实例
const service = axios.create({
  // 旧代码用 process.env.BASE_URL，Vue CLI 已占用该变量，改用 VUE_APP_BASE_URL（见 .env）
  baseURL: process.env.VUE_APP_BASE_URL || '/api', // api的base_url
  timeout: 15000                  // 请求超时时间2
})

// request拦截器
service.interceptors.request.use(config => {
  config.headers.token = localStorage.getItem('token')
  return config
}, error => {
  // Do something with request error
  console.error(error) // for debug
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;

    if (res.code === 1000 || res.code === '1000' || res.code === 0 || res.code === '0' || res.code === 200) {

      return res;
    }
    if (res.code == '100') {
      return res.info;
    } else if (res.code == "20011") {
      Message({
        showClose: true,
        message: res.msg,
        type: 'error',
        duration: 500,
        onClose: () => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        }
      });
      return Promise.reject("未登录")
    } else {
      Message({
        message: res.msg,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(res)
    }
  },
  error => {
    console.error('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)
export default service

